import React, { useState, useCallback } from 'react'

// redux
import { connect } from "react-redux";

// bootstrap
import { Spinner } from "react-bootstrap";

// icons
import { BiCheck } from "react-icons/bi";

// formik
import {
    useFormik, //hook for functonal components
} from 'formik'

// yup
import * as Yup from 'yup'
import { useEffect } from 'react';

// API
import { getShippingMethodsApi, cancelGetShippingMethodsApi, getCartDetailsAfterPaymentMethodApi } from 'utlis/Apis/Shipping_Api';

// react toastify
import { toast } from "react-toastify";

// app messages
import {
	ERROR_WHILE__NAME,
	UNKNOWN_ERROR_OCCURED,
} from "utlis/AppMessages/AppMessages";

// actions
import { setCartDetails, setCartImages, setCartItem } from 'redux/actions/actionCart';

function CheckoutStepTwo(props) {
    // props
    const {
        commonToken,
        cartDetails,
        tempOrderId,
        setCartDetails,
		setCartItem,
		setCartImages,

        allowedToDisplay,
        allCheckoutDetails,
        setAllCheckoutDetails,

        checkoutCurrentStep,
        setCheckoutCurrentStep,

        completedcheckoutSteps,
        setCompletedCheckoutSteps,

        shippingMethod,
        setShippingMethod,
    } = props

    // consts
    const DEFAULT_SHIPPING_METHOD_DETAILS = {
        shippingsetting_id: 0,
        shipping_name: "Regular Shipping",
        carrier_name: "",
        description_for_customer: "",
        estimated_transit_time: "",
        shipping_rates: {
            amount_type: "",
            shipping_rate: 0,
            shipping_rate_currency: "$0.00"
        }
    }

    // states
    const [btnDisabled, setBtnDisabled] = useState(false)
    const [sectionLoading, setSectionLoading] = useState(true)

    const [allShippingMethods, setAllShippingMethods] = useState([])
    const [selectedShippingMethodName, setSelectedShippingMethodName] = useState(null)

    // initial form values
    const initialFormValues = {
        shippingMethod: "",
    }

    // handle form validations
    const formValidationSchema = Yup.object({
        shippingMethod: Yup.string().required('This field is required'),
    })


    // handle form submmision
    const onFormSubmit = values => {
        if (values) {
            setShippingMethod(selectedShippingMethodName)

            setAllCheckoutDetails({ ...allCheckoutDetails, ...values, shippings: selectedShippingMethodName })

            setCompletedCheckoutSteps([...completedcheckoutSteps, "step2"])

            setCheckoutCurrentStep("step3")

            window.scrollTo(0, 0)
        }
    }

    // formik hook
    const formik = useFormik({
        initialValues: initialFormValues,
        validationSchema: formValidationSchema,
        onSubmit: onFormSubmit,
        enableReinitialize: true
    })

    // shipping method change
    const handleShippingMethodChange = (ev, item) => {
        if (item) {
            formik.setFieldValue("shippingMethod", item.shipping_name)

            // setting method name to show
            setSelectedShippingMethodName(item)

            getCartDetailsAfterPaymentMethod(item.shippingsetting_id)
        }
    }

    // when user wants to shipping method
    const handleChangeMethod = (ev) => {
        ev.preventDefault()
        // const updatedSteps = completedcheckoutSteps.filter(item => item !== "step2")

        setCompletedCheckoutSteps(["step1"])
    }

    const getCartDetailsAfterPaymentMethod = useCallback((shippingId) => {
        // loading
        setSectionLoading(true)

        // required data
        const requiredData = {
            temp_order_id: tempOrderId,
            shippingsetting_id: shippingId
        }

        // getting data
        getCartDetailsAfterPaymentMethodApi(commonToken, requiredData).then(res => {
            const resData = res.data

            // loading
            setSectionLoading(false)

            if (resData.success) {
                const cartData = resData.data
                // saving items to global store
                setCartItem(cartData.content);
                setCartImages(cartData.images);
                setCartDetails({
                    cart_discount: cartData.cart_discount,
                    cart_items: cartData.cart_items,
                    cart_qty: cartData.cart_qty,
                    cart_sub_total: cartData.cart_sub_total,
                    cart_total: cartData.cart_total,
                    coupon_code: cartData.coupon_code,
                    coupon_value: cartData.coupon_value,
                    allCartData: cartData
                });
            }

            if (resData.error) {
                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(resData.message || UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500
                });
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getCartDetailsAfterPaymentMethodApi `, err.message);

            // dismissing all the previous toasts first
            toast.dismiss();

            // showing the error message
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 3000,
                onClose: () => {
                    // loading
                    setSectionLoading(false)
                },
            });
        })
    }, [tempOrderId])

    useEffect(() => {
        console.log("cartDetails ", cartDetails);
        if (checkoutCurrentStep === "step2") {
            // loading
            setSectionLoading(true)
    
            // required data
            const requiredData = {
                cart_weight: cartDetails?.allCartData?.cart_weight,
                cart_total: cartDetails?.allCartData?.cart_sub_total_amount
            }
    
            // getting data
            getShippingMethodsApi(commonToken, requiredData).then(res => {
                const resData = res?.data

                // loading
                setSectionLoading(false)
    
                if (resData.success) {
                    setAllShippingMethods(resData?.data?.shippings)

                    if(cartDetails?.allCartData?.shipping_setting_id) {
                        const data = {
                            shippingsetting_id: cartDetails?.allCartData?.shipping_setting_id,
                            shipping_name: cartDetails?.allCartData?.shipping_service,
                            shipping_rates: {
                                shipping_rate: cartDetails?.allCartData?.shipping_amount,
                                shipping_rate_currency: cartDetails?.allCartData?.shipping_amount_currency
                            }
                        }

                        formik.setFieldValue("shippingMethod", data.shipping_name)

                        // setting method name to show
                        setSelectedShippingMethodName(data)
                    }
                }
    
                if (resData.error) {
                    // dismissing all the previous toasts first
                    toast.dismiss();
    
                    // showing the error message
                    toast.error(resData.message || UNKNOWN_ERROR_OCCURED, {
                        autoClose: 2500
                    });
                }
            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} getShippingMethodsApi `, err.message);
    
                // dismissing all the previous toasts first
                toast.dismiss();
    
                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 3000,
                    onClose: () => {
                        // loading
                        setSectionLoading(false)
                    },
                });
            })
        }

        return () => {
            cancelGetShippingMethodsApi && cancelGetShippingMethodsApi()
        }
    }, [cartDetails?.allCartData?.cart_weight, cartDetails?.allCartData?.cart_sub_total_amount, checkoutCurrentStep])


    return (
        <React.Fragment>
            {
                allowedToDisplay ? (
                    <React.Fragment>
                        {
                            completedcheckoutSteps?.length && completedcheckoutSteps.find(item => item === "step2") ? (
                                <div className="after-header border-bottom pb-3 mb-3">
                                    <div className="ah-inner d-flex">
                                        <div className="check me-3 d-flex align-items-center justify-content-center">
                                            <BiCheck fontSize={23} color={"#333"} />
                                        </div>
                                        <div className="content media-body st-fs-15">
                                            <p className="head st-fw-600 mb-0">Shipping method</p>
                                            <p className="info mb-0">
                                                <span className="st-fw-600">{shippingMethod.shipping_name}</span>
                                                <span className="ms-3 st-fs-14 cursor-pointer" onClick={handleChangeMethod}>Change Method</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="content-view mb-3">
                                    <div className="cv-inner">
                                        <div className="head-container mb-3">
                                            <p className="head mb-1 st-fs-25">Shipping method</p>
                                        </div>

                                        <div className="form-content position-relative step2">
                                            <form
                                                onSubmit={formik.handleSubmit}
                                                noValidate
                                                autoComplete="off">
                                                {
                                                    allShippingMethods?.length ? allShippingMethods.map(item => (
                                                        <label key={item.shippingsetting_id} className="shipping-method-label d-block cursor-pointer">
                                                            <input type="radio"
                                                                value={item.shipping_name}
                                                                className="d-none"
                                                                checked={formik.values.shippingMethod === item.shipping_name}
                                                                onChange={ev => handleShippingMethodChange(ev, item)}
                                                            />
                                                            <span className="main d-flex align-items-center">
                                                                <span className="round d-flex align-items-center justify-content-center"></span>
                                                                <span className="text d-flex media-body ps-3">
                                                                    <div className="lt">
                                                                        <span className="d-block head st-fw-600 st-fs-15 mb-1">{item.shipping_name}</span>
                                                                        {
                                                                            item.estimated_transit_time ? (
                                                                                <span className="d-block desc st-fs-14" style={{color: '#555'}}>
                                                                                    <span className="st-fw-600">Estimated transit time: </span> {item.estimated_transit_time}
                                                                                </span>
                                                                            ) : null
                                                                        }
                                                                        {
                                                                            item.description_for_customer ? (
                                                                                <span className="d-block desc st-fs-14" style={{color: '#555'}}>
                                                                                    <span className="st-fw-600">Description: </span> 
                                                                                    {item.description_for_customer}
                                                                                </span>
                                                                            ) : null
                                                                        }
                                                                    </div>
                                                                    <div className="rt ms-auto ps-2">
                                                                        <span className="d-block price st-fs-14">{item?.shipping_rates?.shipping_rate_currency}</span>
                                                                    </div>
                                                                </span>
                                                            </span>
                                                        </label>
                                                    )) : (
                                                        <label className="shipping-method-label d-block cursor-pointer">
                                                            <input type="radio"
                                                                value="Regular Shipping"
                                                                className="d-none"
                                                                checked={formik.values.shippingMethod === "Regular Shipping"}
                                                                onChange={ev => handleShippingMethodChange(ev, DEFAULT_SHIPPING_METHOD_DETAILS)}
                                                            />
                                                            <span className="main d-flex align-items-center">
                                                                <span className="round d-flex align-items-center justify-content-center"></span>
                                                                <span className="text d-flex media-body ps-3">
                                                                    <div className="lt">
                                                                        <span className="d-block head st-fw-600 st-fs-15">Regular Shipping</span>
                                                                    </div>
                                                                    <div className="rt ms-auto ps-2">
                                                                        <span className="d-block price st-fs-14">Free</span>
                                                                    </div>
                                                                </span>
                                                            </span>
                                                        </label>
                                                    )
                                                }

                                                {/* btns */}
                                                <div className="btns w-100 pt-2">
                                                    <button type="submit" className="btn" disabled={btnDisabled}>
                                                        Continue
                                                    </button>
                                                </div>
                                            </form>

                                            {
                                                /* LOADING */
                                                sectionLoading ? (
                                                    <div className="section-loading position-absolute align-items-center d-flex h-100 justify-content-center section-loading w-100" style={{ top: 0, left: 0, background: "rgba(255,255,255,0.5)" }}>
                                                        <Spinner animation="border" />
                                                    </div>
                                                ) : null
                                            }
                                        </div>
                                    </div>
                                </div>
                            )

                        }
                    </React.Fragment>
                ) : null
            }
        </React.Fragment>
    )
}


const getDataFromStore = (state) => {
    return {
        commonToken: state.auth.commonToken,
        cartDetails: state.cart.cartDetails,
        tempOrderId: state.auth.tempOrderId,
    };
};

const dispatchActionsToProps = (dispatch) => {
	return {
		setCartDetails: cartDetails => dispatch(setCartDetails(cartDetails)),
		setCartItem: cartData => dispatch(setCartItem(cartData)),
		setCartImages: cartData => dispatch(setCartImages(cartData)),
	};
};

export default connect(getDataFromStore, dispatchActionsToProps)(CheckoutStepTwo);